/**
 * Created by zzy on 2019/8/26.
 */
import ShowDataNode from './ShowDataNode.vue'
export default ShowDataNode



// WEBPACK FOOTER //
// ./src/views/common/showDataNode/index.js